import { ingredientPhotosResponseSchema, ingredientPhotoUploadResponseSchema, mediaDtoSchema, okResponseSchema, recipeDetailSchema, reportPhotoResponseSchema, reportRequestSchema, } from '@fewerbags/schema';
/** Wrap a file in a single-field `file` FormData body for multipart uploads. */
function fileForm(file) {
    const form = new FormData();
    const name = file instanceof File ? file.name : 'photo.jpg';
    form.append('file', file, name);
    return form;
}
/**
 * /api/v1/media — image uploads, serving URLs, the shared ingredient-photo
 * layer, and the recipe photo endpoints (POST/DELETE /api/v1/recipes/:id/photo,
 * derived from `base` by swapping the trailing `/media` for `/recipes`).
 */
export function createMediaApi(http, base) {
    const recipesBase = base.replace(/\/media$/, '/recipes');
    return {
        /** Upload an image; the server resizes, strips EXIF/GPS, and re-encodes it. */
        upload: async (file, opts) => http.postForm(base, fileForm(file), {
            query: { kind: opts.kind, scope: opts.scope },
            parse: mediaDtoSchema,
        }),
        /** Same-origin URL for the full-size image; use directly as an `<img src>`. */
        urlFor: (id) => `${base}/${encodeURIComponent(id)}`,
        /** Same-origin URL for the thumbnail. */
        thumbUrlFor: (id) => `${base}/${encodeURIComponent(id)}/thumb`,
        /** 409 MEDIA_IN_USE when a recipe or ingredient photo still references it. */
        remove: async (id) => http.del(`${base}/${encodeURIComponent(id)}`, undefined, { parse: okResponseSchema }),
        /** Shared ingredient photos: visible to every household, never attributed (D12). */
        ingredientPhotos: async (ingredientId) => http.get(`${base}/ingredients/${encodeURIComponent(ingredientId)}/photos`, {
            parse: ingredientPhotosResponseSchema,
        }),
        uploadIngredientPhoto: async (ingredientId, file) => http.postForm(`${base}/ingredients/${encodeURIComponent(ingredientId)}/photos`, fileForm(file), { parse: ingredientPhotoUploadResponseSchema }),
        /**
         * Report a shared photo (once per household; 409 ALREADY_REPORTED on
         * repeat). Hides it once enough households report it; returns whether this report did.
         */
        reportPhoto: async (photoId, input = { reason: 'other' }) => http.post(`${base}/photos/${encodeURIComponent(photoId)}/report`, reportRequestSchema.parse(input), { parse: reportPhotoResponseSchema }),
        /** POST /api/v1/recipes/:id/photo — sets the recipe's photo; returns the updated recipe. */
        uploadRecipePhoto: async (recipeId, file) => http.postForm(`${recipesBase}/${encodeURIComponent(recipeId)}/photo`, fileForm(file), {
            parse: recipeDetailSchema,
        }),
        /** DELETE /api/v1/recipes/:id/photo — clears the recipe's photo; returns the updated recipe. */
        removeRecipePhoto: async (recipeId) => http.del(`${recipesBase}/${encodeURIComponent(recipeId)}/photo`, undefined, {
            parse: recipeDetailSchema,
        }),
    };
}
//# sourceMappingURL=media.js.map